var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D27F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7275 8C30.5355 8.0002 31.9998 9.46453 32 11.2725V28.7275C31.9998 30.5355 30.5355 31.9998 28.7275 32H11.2725C9.46453 31.9998 8.0002 30.5355 8 28.7275V11.2725C8.00019 9.46453 9.46453 8.00019 11.2725 8H28.7275ZM11.2725 10.1816C10.6703 10.1818 10.1818 10.6703 10.1816 11.2725V28.7275C10.1818 29.3297 10.6703 29.8182 11.2725 29.8184H28.7275C29.3297 29.8182 29.8182 29.3297 29.8184 28.7275V11.2725C29.8182 10.6703 29.3297 10.1818 28.7275 10.1816H11.2725ZM26.5449 11.2734C27.7494 11.2736 28.7263 12.2496 28.7266 13.4541V16.7275C28.7265 17.9322 27.7496 18.9091 26.5449 18.9092H13.4531C12.2485 18.909 11.2716 17.9322 11.2715 16.7275V13.4541C11.2717 12.2496 12.2486 11.2736 13.4531 11.2734H26.5449ZM13.4531 13.4541V16.7275H26.5449V13.4541H13.4531Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon);
export default __webpack_public_path__ + "static/media/banner-icon.07f28384.svg";
export { ForwardRef as ReactComponent };